import { Seo } from "@/lib/seo";
import { Link, useLocation } from "react-router-dom";

// NotFoundPage — generic 404 fallback.
// Ported 1:1 from dane main (etf-website/not-found/page.tsx), which renders the
// shared `EtfNotFound` card with entityName="Page", slug=pathname, and a
// Back-to-Home link. The shell Layout renders the surrounding nav + footer, so
// this page only needs the centered card. `etfHref()` is replaced by "/".

export function NotFoundPage() {
  const { pathname } = useLocation();
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Seo
        title="Page Not Found"
        description="The page you're looking for doesn't exist."
        noindex
      />
      <div className="text-center">
        <div className="text-6xl font-light text-[var(--etf-white3)] mb-4">404</div>
        <h1 className="text-2xl font-light text-[var(--etf-white)] mb-2">Page Not Found</h1>
        <p className="text-sm text-[var(--etf-white3)] mb-6">
          No page exists with the slug &ldquo;{pathname}&rdquo;.
        </p>
        <Link
          to="/"
          className="font-[family-name:var(--font-instrument)] text-sm text-[var(--etf-orange)] no-underline tracking-[0.06em] inline-flex items-center gap-1.5 transition-[gap] duration-200 hover:gap-2.5"
        >
          Back to Home &rarr;
        </Link>
      </div>
    </div>
  );
}
